import { render, staticRenderFns } from "./PaymentPagev2.vue?vue&type=template&id=006ae847&scoped=true&"
import script from "./PaymentPagev2.vue?vue&type=script&lang=js&"
export * from "./PaymentPagev2.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPagev2.vue?vue&type=style&index=0&id=006ae847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ae847",
  null
  
)

export default component.exports